import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconGoalQuote = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 25 25",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#a)",
		children: [/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M24.64 12.535c0 6.628-5.372 12-12 12-6.627 0-12-5.372-12-12 0-6.627 5.373-12 12-12 6.628 0 12 5.373 12 12Z"
		}), /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M7.826 4.32c-1.289 0-2.337.918-2.337 2.045v12.27c0 1.127 1.048 2.044 2.337 2.044h9.348c1.289 0 2.337-.917 2.337-2.044V9.432h-4.674c-.646 0-1.168-.457-1.168-1.023V4.32H7.825Zm7.011 0v4.09h4.674l-4.674-4.09ZM8.41 6.366h2.337c.322 0 .585.23.585.512 0 .28-.263.51-.585.51H8.41c-.321 0-.584-.23-.584-.51 0-.281.263-.512.584-.512Zm0 2.045h2.337c.322 0 .585.23.585.512 0 .28-.263.51-.585.51H8.41c-.321 0-.584-.23-.584-.51 0-.282.263-.512.584-.512Zm.585 3.068h7.01c.647 0 1.169.457 1.169 1.022v2.045c0 .565-.522 1.022-1.168 1.022H8.995c-.647 0-1.169-.457-1.169-1.022V12.5c0-.566.522-1.022 1.169-1.022Zm0 1.022v2.045h7.01V12.5h-7.01Zm5.258 5.112h2.337c.321 0 .584.23.584.511s-.263.511-.584.511h-2.337c-.322 0-.585-.23-.585-.51 0-.282.263-.512.585-.512Z"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", { d: "M0 0h25v25H0z" })
	}) })]
});
export default SvgIconGoalQuote;
